export enum Driver {
    Player = 'player',
    AI = 'ai'
}
